// ABOUTME: Checks whether slot management is enabled for a given country and business line.
// ABOUTME: Returns true if any of the three slot management feature flags is active.

import {isFeatureEnabled} from '@hconnect/apiclient'

import {api} from '../../../../App.store'
import {useFeaturesCheckFetcher} from '../../../../common/hooks/useFeaturesCheckFetcher'

const SLOT_MANAGEMENT_FLAGS = [
  'enableRmcSlotManagement',
  'enableSlotManagementForRmcOrderIntake',
  'enableSlotManagementForRmcOrderManagement',
] as const

export const useSlotManagementEnabled = (
  countryId: string | undefined,
  businessLine: string | undefined
): boolean => {
  const {data: features} = useFeaturesCheckFetcher(api)
  if (!features || !countryId) return false

  const scopes: Record<string, string> = {countryId}
  if (businessLine) {
    scopes.businessLine = businessLine.toUpperCase()
  }
  return SLOT_MANAGEMENT_FLAGS.some((flag) => isFeatureEnabled(features, scopes, flag))
}
